import {Component} from "@angular/core";
import {ProductService} from "./product.service";
import {Product} from "./product";
import {Router} from "@angular/router";
import {OrderAdminComponent} from "./order-admin.component";
import {MemberService} from "./member.service";
import {UserService} from "./user.servise";
import {Headers, Http,Response} from "@angular/http";
import {Observable} from "rxjs/Rx";
import 'rxjs/Rx';

declare var fetch;


@Component({
  selector:'upload',
  template:`
       <div class="container">       
          <div class="title-clothes">
        <div class="title-clothes-line"></div>商品管理<div class="title-clothes-line2"></div>
       
        </div> 
        <div class="update">
        <table width="100%">
        <tr> 
            <td></td>
            <td>商品名稱</td>
            <td>底版結構</td>
            <td>震動特性</td>
            <td>反發特性</td>
            <td>拍柄尺寸</td>
            <td>拍柄底寬</td>
            <td>板面尺寸</td>
            <td>板面厚度</td>
            <td>球拍出產地</td>
            <td>性質</td>
            <td>速度</td>
            <td>旋轉</td>
            <td>控制</td>
            <td>硬度</td>
            <td>膠皮出產地</td>
            <td>其他出產地</td>
            <td>修改</td>
            
        </tr>
        <tr *ngFor="let p of products">
            <td><img src={{p.imgsrc}} width="80px" height="80px"></td>
            <td>{{p.name}}</td>
            <td><input type="text" value={{p.blade_structure}} #ustructure></td>
            <td><input type="text" value={{p.blade_vibrate}} #uspecial></td>
            <td><input type="text" value={{p.blade_special}} #uvibrate></td>
            <td><input type="text" value={{p.blade_holdsize}} #uholdsize></td>
            <td><input type="text" value={{p.blade_holdwidth}} #uholdwidth></td>
            <td><input type="text" value={{p.blade_hitsize}} #uhitsize></td>
            <td><input type="text" value={{p.blade_thick}} #uthick></td>
            <td><input type="text" value={{p.blade_madein}} #ublademadein></td>
            <td><input type="text" value={{p.robber_property}} #uproperty></td>
            <td><input type="text" value={{p.robber_speed}} #uspeed></td>
            <td><input type="text" value={{p.robber_spin}} #uspin></td>
            <td><input type="text" value={{p.robber_control}} #ucontrol></td>
            <td><input type="text" value={{p.robber_hard}} #uhard></td>
            <td><input type="text" value={{p.robber_madein}} #urobbermadein></td>
            <td><input type="text" value={{p.other_madein}} #uothermadein></td>
            <td><button (click)="update(p.id,ustructure.value,uspecial.value,uvibrate.value,uholdsize.value,uholdwidth.value,uhitsize.value,uthick.value,ublademadein.value,uproperty.value,uspeed.value,
            uspin.value,ucontrol.value,uhard.value,urobbermadein.value,uothermadein.value)">修改</button></td>
        
        
        </tr>
        </table></div>
        <div class="new_button2" style="text-align: center;margin-bottom: 30px;">
       <button style="color: white;background-color: #CC3366;border: none;margin-left: 30px; margin-bottom: 30px;" (click)="gotoOrder()">訂單管理</button></div>
    <div class="new_button2" style="text-align: center;margin-bottom: 30px;">
       <button style="color: white;background-color: #CC3366;border: none;" (click)="gotoNewUpload()">上傳商品</button></div>
  </div>

  <!--<button (click)="postTestConfig(other_madein.value,t4.value)">testConfig</button>-->

    `,
  styles:[`    
    button{
    border: none;
    color:white;
    background-color: #CC3366;
    font-size: 20px;
    float: right;
    }
    label{
    margin-top: 10px;
    }
    table{
    font-size: 20px;
    margin-bottom: 50px;
    }
    tr{
    height:40px;
    }
   
    
    `]
})

export class ParameterComponent{

  imageSource: string;
  constructor(private productService:ProductService,public http:Http,private router:Router,private memberservice:MemberService,private userservice:UserService){
    //this.loggedIn = !!localStorage.getItem('auth_token');//
    this.url = 'http://45.79.133.15:3000/image';
  }
  products:Product[];
  errorMessage:string;
  response:string;
//    ngOnInit(){this.getProducts();}
  public url: string;
  headers: Headers;

  //
  //constructor(private router:Router,//++ private memberservice:MemberService,private userservice:UserService){}


  ngOnInit(){
    this.getProducts();
    if(this.userservice.isLoggedIn()==true){
       if(localStorage.getItem('userid')=='32'){//32 = admin
                this.router.navigate(['/parameter']);
            }else{
                this.router.navigate(['/']);
            }
    }else{this.router.navigate(['/member']);};
  }
  //

  getProducts(){
    this.productService.getProduct()
      .subscribe(
        products => this.products = products,
        error =>  this.errorMessage = <any>error);

  }

  update(id:number,ustructure:string,uspecial:string,uvibrate:string,uholdsize:string,uholdwidth:string,uhitsize:string,uthick:string,ublademadein:string,uproperty:string,uspeed:string,
  uspin:string,ucontrol:string,uhard:string,urobbermadein:string,uothermadein:string) {
    const data = {
      blade_structure:ustructure,
      blade_vibrate:uvibrate,
      blade_special:uspecial,
      blade_holdsize:uholdsize,
      blade_holdwidth:uholdwidth,
      blade_hitsize:uhitsize,
      blade_thick:uthick,
      blade_madein:ublademadein,
      robber_property:uproperty,
      robber_speed:uspeed,
      robber_spin:uspin,
      robber_control:ucontrol,
      robber_hard:uhard,
      robber_madein:urobbermadein,
      other_madein:uothermadein
}
    var r = window.confirm("Are you sure to update??")
    if (r == true) {
      this.productService.updateData(id, data)
        .subscribe(
          data => this.response = JSON.stringify(data),
          error =>console.log(error),
          ()=> {
            window.alert("修改成功")
            window.location.reload();
          }
        );
    }
  }

  onPost(name:string,price:number,imgsrc:string,description:string,category:string,brand:string,blade_structure:string,blade_special:string,
         blade_vibrate:string,blade_hitsize:string,blade_thick:string,blade_holdwidth:string,blade_holdsize:string,blade_madein:string){
    const data={
      name:name,
      price:price,
      imgsrc:imgsrc,
      description:description,
      category:category,
      brand:brand,
      blade_structure:blade_structure,
      blade_special:blade_special,
      blade_vibrate:blade_vibrate,
      blade_hitsize:blade_hitsize,
      blade_thick:blade_thick,
      blade_holdwidth:blade_holdwidth,
      blade_holdsize:blade_holdsize,
      blade_madein:blade_madein
    };
    this.productService.postData(data)
      .subscribe(
        data => this.response = JSON.stringify(data),
        error =>console.log(error),
        ()=> {
          window.alert("上傳成功");
          window.location.reload();
        }
      );

  }

  onPost2(name:string,price:number,imgsrc:string,description:string,category:string,brand:string,robber_property:string,robber_speed:string,
          robber_spin:string,robber_control:string,robber_hard:string,robber_madein:string){
    const data={
      name:name,
      price:price,
      imgsrc:imgsrc,
      description:description,
      category:category,
      brand:brand,
      robber_property:robber_property,
      robber_speed:robber_speed,
      robber_spin:robber_spin,
      robber_control:robber_control,
      robber_hard:robber_hard,
      robber_madein:robber_madein
    };
    this.productService.postData(data)
      .subscribe(
        data => this.response = JSON.stringify(data),
        error =>console.log(error),
        ()=> {
          window.alert("上傳成功");
          window.location.reload();
        }
      );
  }

  onPost3(name:string,price:number,imgsrc:string,description:string,category:string,brand:string,other_madein:string){
    const data={
      name:name,
      price:price,
      imgsrc:imgsrc,
      description:description,
      category:category,
      brand:brand,
      other_madein:other_madein,
    };
    this.productService.postData(data)
      .subscribe(
        data => this.response = JSON.stringify(data),
        error =>console.log(error),
        ()=> {
          window.alert("上傳成功");
          window.location.reload();
        }
      );
  }

  deleteData(id:number){
    var r = window.confirm("Are you sure to delete??")
    if (r == true) {
      this.productService.deleteData(id)
        .subscribe((response)=>{
        }
        );
    }
  }

  change(file){
    var xhr = new XMLHttpRequest()
    let formData = new FormData();
    formData.append("file",file);
    Observable.fromPromise(fetch(this.url,{method:'post', body: formData}))
      .subscribe((response:any)=> {
        response.json().then(json => {
          this.imageSource = `http://${json['imgsrc']}`
        })
      });

  }
  gotoNewUpload(){
    this.router.navigate(['/upload']);
  }
  gotoOrder(){
    this.router.navigate(['/orderAdmin']);
  }

  postTestConfig(made:string,t4:string){ //for test, not in use currently
    const data={
      config_json_str:[2,4,1,7,95,made,t4],
      config_purpose:"tryConfig"
    };
    this.productService.postConfigData(data)
      .subscribe(
        data => this.response = JSON.stringify(data),
        error =>console.log(error)
      );
  }




}



// WEBPACK FOOTER //
// ./src/app/blade_parameter.component.ts